// extracted by mini-css-extract-plugin
export default {"no-scrollbar":"SensorStatusBoardItem_no-scrollbar__K7NUV","sensor-status-board-item":"SensorStatusBoardItem_sensor-status-board-item__2N2rw"};